/**
 * Reducer relating to getting/setting configuration parameters for a Sparx
 * Web application, including saving persistent information to browser local
 * storage
 */

import { fromJS } from 'immutable';

import { ADD_CONFIG_PARAMETERS } from './actions';

export const CONFIG_PARAMETERS_KEY = 'configParameters';

// In default state, set up allowed actions for student_login:
const defaultState = fromJS({
    allowedActions: ['student_login'],
});

export function configParametersReducer(state = defaultState, action) {
    switch (action.type) {
        case ADD_CONFIG_PARAMETERS:
            // If allowTethering is supplied, create allowedActions state.
            const allowTethering = action.parameters.get('allowTethering', null);
            if (allowTethering !== null) {
                const allowedActions = allowTethering ? ['tethering'] : ['student_login'];
                state = state.set('allowedActions', fromJS(allowedActions));
            }

            return state.merge(action.parameters);
    }
    return state;
}
